import { Guardian } from '@xaamin/guardian';

Guardian.define('root.access', (user) => {
  return user.is(['root', 'admin']);
});

Guardian.define('app.access', (user) => {
  return !user.is(['external']);
});

Guardian.define('external.access', (user) => {
  return user.is(['external', 'user']);
});

Guardian.define('profile.access', (user) => {
  return user.is(['root', 'user', 'owner', 'api-integration']);
});

Guardian.define('account.access', (user) => {
  return user.is(['root', 'owner']);
});
